import React from 'react';
import polyUtil from "polyline-encoded";
import { inject, observer } from 'mobx-react';
import { observable, action, autorun } from 'mobx';
import _ from "lodash";

import LeafletMap from "../../LeafletMap";
import { getCenter } from "../../Map/getCenterLatLng";
import moment from "moment";
import { toJS } from "mobx/lib/mobx";
import WorkOrderInfoTable from "./WorkOrderInfoTable";

@inject('workOrderStore', 'workOrderRouteStore', 'priorityStore', 'maintenanceTypeStore', 'workOrderStatusStore', 'userStore')
@observer
export default class WorkOrderRouteMap extends React.Component {
  dispose;

  componentDidMount() {
    const { workOrderStore } = this.props;

    this.dispose = autorun(() => {
      const { workOrderStore, workOrderRouteStore } = this.props;
      const { assigned_to_all } = workOrderStore;
      const { viewBy, show } = workOrderRouteStore;

      const workOrdersGroupedByAssignedTo = _.groupBy(workOrderStore.filteredWorkOrders.filter(wo => {
        if (viewBy && show) {
          switch (+viewBy) {
            case 1:
              return +wo.status_id === +show;
            case 2:
              return +wo.priority_id === +show;
            case 3:
              return +wo.maintenance_type === +show;
            case 4:
              return +wo.assigned_to === +show;
            default:
              return true;
          }
        } else return true;
      }).sort((a, b) => new Date(a.scheduled_date).getTime() - new Date(b.scheduled_date).getTime()), 'assigned_to');
      workOrderRouteStore.populatePolylines(workOrdersGroupedByAssignedTo);
    });

    workOrderStore.selectedTime = 0;
    workOrderStore.timeRange = [];
  }

  componentWillUnmount() {
    this.props.workOrderRouteStore.setPolylines([]);

    if (this.dispose)
      this.dispose();
  }

  getFilteredMarkerIcons = markers => markers.reduce((acc, marker) => {
    if (!marker.latitude || !marker.longitude) return acc;
    const { workOrderStore } = this.props;
    if (!!workOrderStore.viewBy && !!workOrderStore.show) {
      switch (+workOrderStore.viewBy) {
        case 1: if (!marker.work_orders.find(item => +item.status_id === +workOrderStore.show)) return acc; else break;
        case 2: if (!marker.work_orders.find(item => +item.priority_id === +workOrderStore.show)) return acc; else break;
        case 3: if (!marker.work_orders.find(item => +item.maintenance_type === +workOrderStore.show)) return acc; else break;
        case 4: if (!marker.work_orders.find(item => +item.assigned_to === +workOrderStore.show)) return acc; else break;
        default: break;
      }
    }

    acc.push({
      id: 'work_order_marker-' + marker.work_orders[0].id,
      station_id: marker.station_id,
      position: [marker.latitude, marker.longitude],
      latitude: marker.latitude, longitude: marker.longitude,
      icon: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px;">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `,
      iconHighlighted: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px; border-radius: 100px; box-shadow: #367fa9 0 0 15px 3px">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `
    });
    return acc;
  }, []);

  getPopupBox = marker => {
    const { workOrderStore } = this.props;

    return (
      <div>
        <strong style={{ fontSize: '15px', fontWeight: 'bold' }}>{marker.station_name}</strong><br />
        <span className="fa fa-close" style={{ position: 'absolute', right: 2, top: 2 }}
          onClick={() => this.props.workOrderRouteStore.selectedMarker = null} />
        {!!marker.duration ? <small>{marker.duration}</small> : ''}
        <br />
        <div style={{ maxHeight: '220px', overflowY: 'scroll' }}>
          {marker.work_orders
            .filter(work_order => {
              if (!workOrderStore.show) return true;
              switch (+workOrderStore.viewBy) {
                case 1:
                  return +work_order.status_id === +workOrderStore.show;
                case 2:
                  return +work_order.priority_id === +workOrderStore.show;
                case 3:
                  return +work_order.maintenance_type === +workOrderStore.show;
                default:
                  return false;
              }
            })
            .map(work_order => (
              <div key={`station-${marker.station_id}-ticket-${work_order.id}`}>
                <a href={`#/monitoring/work_order/tabular/${work_order.id}/view`}>Work Order {work_order.id}</a>
                <table style={{ padding: '10px' }}>
                  <tbody>
                    <tr>
                      <th>Summary</th>
                      <td>{work_order.title}</td>
                    </tr>
                    <tr>
                      <th>Scheduled Date</th>
                      <td>{moment.utc(work_order.scheduled_date).format('YYYY-MM-DD')}</td>
                    </tr>
                    <tr>
                      <th>Status</th>
                      <td>{work_order.status && work_order.status.caption}</td>
                    </tr>
                    <tr>
                      <th>Priority</th>
                      <td>{work_order.priority && work_order.priority.caption}</td>
                    </tr>
                    <tr>
                      <th>Type</th>
                      <td>{work_order.type && work_order.type.caption}</td>
                    </tr>
                  </tbody>
                </table>
                <br />
              </div>
            ))}
        </div>
      </div>
    )
  };

  render() {
    const { workOrderStore, workOrderRouteStore, workOrderStatusStore, maintenanceTypeStore, priorityStore } = this.props;

    // const {mapCenter, markers, markerIcons} = this.state;
    const markers = workOrderStatusStore.items.length > 0 && priorityStore.items.length > 0 && maintenanceTypeStore.items.length > 0
      ? workOrderStore.getMarkers()
      : [];

    const markerIcons = this.getFilteredMarkerIcons(markers);
    let mapCenter = getCenter(markerIcons);

    const { polylines } = workOrderRouteStore;

    return <div>
      <div className='inline-grid-reverse full-width'>
        <div className='flex-grow'>
          <LeafletMap id='ticket_map'
            center={mapCenter}
            markers={markerIcons}
            selectedMarker={workOrderStore.selectedMarker}
            width='100%'
            polylines={toJS(polylines)}
            onMarkerClick={this.onMarkerClick}
            isLoading={workOrderStore.isLoading}
            onMarkerOver={workOrderStore.onMarkerOver}>
            {workOrderStore.selectedMarker && markers.find(item => +item.station_id === +workOrderStore.selectedMarker) ? <div
              className='map-info-box'>{this.getPopupBox(markers.find(item => +item.station_id === +workOrderStore.selectedMarker))}</div> : null}
          </LeafletMap>
        </div>
        <div className='ticket-filter-group'>
          <WorkOrderInfoTable />
        </div>
      </div>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/WorkOrderRouteMap.js